import {SET_CARDS} from '../actions/types';


const cards = (state = null, action) => {
  switch (action.type) {
    case SET_CARDS:
      return action.payload;
    default:
      return state;
  }
};

export default cards;